import { useTranslation } from '@shared/core';

/**
 * Default intro copy for the Neighborhoods (stay areas) section. Shown to guests when no custom
 * note is set, and mirrored in the admin editor field. Single source of truth so the admin preview
 * and the guest site stay in sync (importable by both apps from `@shared`).
 */
export const useDefaultNeighborhoodsNote = (): string => {
  const { tq } = useTranslation('stayAreasGuest');
  return tq`If you'd like to stay together as a group, have a more independent stay or turn the trip into a longer getaway, explore the best neighborhoods near our venue.`;
};
